import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './progress-bar.magic.css.js';
import script from './progress-bar.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-bar",class:{ 'is-complete': _vm.isComplete },style:(_vm.styles),attrs:{"part":_vm.$p('progress-bar', { 'is-complete': _vm.isComplete })}},[_c('div',{staticClass:"bar",attrs:{"part":"bar"}},[_c('div',{staticClass:"track",class:_vm.bgClass,attrs:{"part":"track"}}),_vm._v(" "),_c('div',{staticClass:"filler",class:[{'filler--top-nav': _vm.isTopNavigationEnabled}, _vm.bgClass],attrs:{"part":"filler"}})])])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-e95d348a_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-e95d348a";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
